module.exports = __webpack_public_path__ + "img/cm_s1-desc.936e15ba.png";